import React from 'react';
import {
  ProgressDots,
  ProgressSegment,
  StepLabel,
  StepMeta,
  StepMetaDivider,
  StepNameLabel,
  StepRow,
  WizardHeaderBlock,
  WizardShell,
  WizardStepDescription,
  WizardTitle
} from './wizardStylesV2';

function WizardChromeV2({
  stepIndex,
  displayTotalSteps,
  title,
  stepName,
  stepDescription,
  stepNotice,
  children
}) {
  const total = Math.max(1, displayTotalSteps ?? 1);
  const safeStep = Math.min(Math.max(0, stepIndex), total - 1);

  return (
    <WizardShell>
      <WizardHeaderBlock>
        <StepRow>
          <StepMeta>
            <StepLabel>{`STEP ${safeStep + 1}/${total}`}</StepLabel>
            {stepName ? (
              <>
                <StepMetaDivider aria-hidden />
                <StepNameLabel>{stepName}</StepNameLabel>
              </>
            ) : null}
          </StepMeta>
          <ProgressDots>
            {Array.from({ length: total }, (_, i) => (
              <ProgressSegment key={i} $active={i <= safeStep} />
            ))}
          </ProgressDots>
        </StepRow>
        {title ? <WizardTitle>{title}</WizardTitle> : null}
        {stepDescription ? <WizardStepDescription>{stepDescription}</WizardStepDescription> : null}
        {stepNotice ?? null}
      </WizardHeaderBlock>
      {children}
    </WizardShell>
  );
}

export default WizardChromeV2;
